import template from './booking-speditor-list.html';
import controller from './booking-speditor-list.controller';
import './booking-speditor-list.styl';

const bookingSpeditorListComponent = {
  template,
  controller,
  controllerAs: 'bookingSpeditorList',
  require: {
    app: '^^app'
  }
};

export default bookingSpeditorListComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-speditor-list/booking-speditor-list.component.js
 **/